import firebase from "../../config/firebase";
import algoliasearch from "algoliasearch";
import { toast } from "react-toastify";
import { createNullCache } from "@algolia/cache-common";
import { RepositoryFactory } from "repository/RepositoryFactory";
const client = algoliasearch("GPYJEAVUBP", "b1f999bc5b264defe930762391d240c6", {
  responsesCache: createNullCache(),
});
let User = RepositoryFactory.get("user");

export const getAllDrivers =
  (ID, hitsPerPage, searchField, currentPage) => async (dispatch) => {
    try {
      dispatch(allDriverLoader(true));

      const index = client.initIndex("users");

      const response = await index.search(searchField, {
        filters: `type:driver AND restaurantID:${ID}`,
        hitsPerPage,
        page: currentPage,
      });
      const { hits, ...rest } = response;
      dispatch({
        type: "GET_ALL_DRIVERS",
        payload: hits,
      });

      dispatch({
        type: "DRIVER_DETAILS",
        payload: rest,
      });
    } catch (error) {
      console.error("Error fetching driver data:", error);
    } finally {
      dispatch(allDriverLoader(false));
    }
  };

export const getRestaurantDrivers = (restaurantID) => async (dispatch) => {
  try {
    firebase
      .firestore()
      .collection("users")
      .where("type", "==", "driver")
      .where("restaurantID", "==", restaurantID)
      .onSnapshot(async (query) => {
        let temp = [];
        if (!query.empty) {
          for (let doc of query.docs) {
            temp.push({ id: doc.id, ...doc.data() });
          }
        }
        dispatch({ type: "GET_RESTAURANT_DRIVERS", payload: temp });
      });
  } catch (err) {
    toast.error(err.message);
  }
};

export const updateDriver = (id, obj, onSuccess) => async (dispatch) => {
  dispatch(updateDriverLoader(true));
  try {
    const res = await User.updateDriver(id, obj);
    dispatch({
      type: "DRIVER_UPDATED",
      payload: { id, obj: res },
    });
    dispatch(updateDriverLoader(false));
    onSuccess();
  } catch (err) {
    toast.error(err?.response?.data?.error || err?.response?.data?.message);
    dispatch(updateDriverLoader(false));
  }
};
export const deleteDriver = (id, onSuccess) => async (dispatch) => {
  dispatch(deleteDriverLoader(true));
  await firebase
    .firestore()
    .collection("users")
    .doc(id)
    .delete()
    .then(() => {
      setTimeout(() => {
        dispatch(deleteDriverLoader(false));
        onSuccess();
        toast.success("Driver has been deleted successfully");
      }, 2000);
    })
    .catch((err) => {
      toast.error(err.message);
      dispatch(deleteDriverLoader(false));
    });
};

export const getDriverApp = () => async (dispatch) => {
  try {
    const docRef = firebase.firestore().collection("driverApp").doc("app");

    const docSnap = await docRef.get();

    if (docSnap.exists) {
      const data = docSnap.data();
      dispatch({
        type: "GET_DRIVER_APP",
        payload: data?.link,
      });
    }
  } catch (err) {
    console.error("Error fetching document:", err);
  }
};

export const fetchDriverRequests = (uid) => (dispatch) => {
  dispatch(driverRequestsLoader(true));

  try {
    const unsubscribe = firebase
      .firestore()
      .collection("driverRequests")
      .where("restaurantID", "==", uid)
      .where("status", "==", "pending")
      .orderBy("createdAt", "desc")
      .onSnapshot(
        async (snapshot) => {
          const requests = await Promise.all(
            snapshot.docs.map(async (doc) => {
              const data = doc.data();
              let driverData = {};

              try {
                const driverDoc = await firebase
                  .firestore()
                  .collection("users")
                  .doc(data.driverId)
                  .get();
                if (driverDoc.exists) {
                  driverData = driverDoc.data();
                }
              } catch (err) {
                console.error(
                  `Error fetching driver data for driverId ${data?.driverId}:`,
                  err.message
                );
              }

              return {
                id: doc.id,
                ...data,
                driverInfo: driverData,
              };
            })
          );

          dispatch({
            type: "FETCH_DRIVER_REQUESTS",
            payload: requests,
          });

          dispatch(driverRequestsLoader(false));
        },
        (error) => {
          console.error(error.message);
          dispatch(driverRequestsLoader(false));
        }
      );

    return unsubscribe;
  } catch (err) {
    console.error(err.message);
    dispatch(driverRequestsLoader(false));
  }
};

export const fetchOrderDetails = (orderId) => (dispatch) => {
  dispatch({ type: "FETCH_ORDER_DETAILS_REQUEST" });

  const unsubscribe = firebase
    .firestore()
    .collection("orders")
    .doc(orderId)
    .onSnapshot(
      (doc) => {
        if (doc.exists) {
          dispatch({
            type: "FETCH_ORDER_DETAILS_SUCCESS",
            payload: { id: doc.id, ...doc.data() },
          });
        } else {
          dispatch({
            type: "FETCH_ORDER_DETAILS_FAILURE",
            payload: "Order not found",
          });
        }
      },
      (error) => {
        dispatch({
          type: "FETCH_ORDER_DETAILS_FAILURE",
          payload: error.message,
        });
      }
    );
  return unsubscribe;
};

export const changeRequestStatus =
  (docId, driverId, value) => async (dispatch) => {
    try {
      const requestRef = firebase
        .firestore()
        .collection("driverRequests")
        .doc(docId);
      await requestRef.update({
        status: value,
      });
      if (value === "accepted") {
        const driverRef = firebase
          .firestore()
          .collection("users")
          .doc(driverId);
        await driverRef.update({
          isAssigned: false,
        });
      }
    } catch (err) {
      console.error(err.message);
    }
  };

const allDriverLoader = (data) => async (dispatch) => {
  dispatch({
    type: "ALL_DRIVER_LOADER",
    payload: data,
  });
};

const updateDriverLoader = (data) => async (dispatch) => {
  dispatch({
    type: "UPDATE_DRIVER_LOADER",
    payload: data,
  });
};

const deleteDriverLoader = (data) => async (dispatch) => {
  dispatch({
    type: "DELETE_DRIVER_LOADER",
    payload: data,
  });
};
const driverRequestsLoader = (data) => async (dispatch) => {
  dispatch({
    type: "DRIVER_REQUESTS_LOADER",
    payload: data,
  });
};
